import UiHelper from './UiHelper';

class Tags
{
    static init()
    {
        this.wrap = document.querySelector('.js-limit-tags');
        if (!this.wrap) return;

        this.onResize = this.onResize.bind(this);

        const maxRows = this.getMaxRows(window.innerWidth);
        this.placeShowAllBtn(maxRows);

        UiHelper.registerHandler('resize', this.onResize, 'throttle');
    }

    static onResize()
    {
        const maxRows = this.getMaxRows(window.innerWidth);
        this.placeShowAllBtn(maxRows);
    }

    static removeShowAllBtn()
    {
        if (this.showAllBtn)
        {
            this.showAllBtn.parentNode.removeChild(this.showAllBtn);
            this.showAllBtn = null;
        }
    }

    static placeShowAllBtn(maxRows)
    {
        this.removeShowAllBtn();

        //loop over tags to determine where to cut off
        let rowCounter = 1,
            startYDetermined = false,
            rowY = 0;

        const tags = Array.from(this.wrap.querySelectorAll('.tag'));

        for (let i=0; i < tags.length; i++)
        {
            const tag = tags[i];
            var rect = tag.getBoundingClientRect();

            if (startYDetermined === false)
            {
                rowY = rect.top;
                startYDetermined = true;
            }

            if (rect.top != rowY)
            {
                rowY = rect.top;
                rowCounter++;
                if (rowCounter > maxRows)
                {
                    //tag is the first on new line
                    //does [...] still fit?
                    tag.insertAdjacentHTML('beforebegin','<a href="#" class="js-show-all-tags tag tag--show-all" rel="nofollow,noindex">...</a>');

                    this.showAllBtn = this.wrap.querySelector('.js-show-all-tags');
                    const btnRect = this.showAllBtn.getBoundingClientRect();

                    if (btnRect.top >= rowY)
                    {
                        //doesn't fit, move it before previous sibling
                        this.showAllBtn.parentNode.insertBefore(this.showAllBtn, this.showAllBtn.previousElementSibling);
                    }

                    this.showAllBtn.addEventListener('click', e =>
                    {
                        e.preventDefault();
                        this.wrap.classList.add('tags__wrap--show-all');
                    });

                    break;
                }
            }
        };
    }

    static getMaxRows(windowWidth)
    {
        //return windowWidth < 768 ? 3 : 2;
        return 2;
    }
}

export default Tags;
